import React from "react";
import { TimePicker12H } from ".././time-picker-12h";
import { DatePickerMMDDYYYY } from ".././date-picker-mmddyyyy";

interface DateTimePicker12HProps {
    value?: string; // Format: ISO string
    onChange?: (value: string) => void;
    disabled?: boolean;
    className?: string;
}

export function DateTimePicker12H({ value, onChange, disabled, className }: DateTimePicker12HProps) {
    // Parse ISO string to date and time
    const parseDateTime = (isoString: string) => {
        if (!isoString) return { date: "", time: "" };
        
        const dateObj = new Date(isoString);
        // Convert to local date string for input type="date"
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        const dateStr = `${year}-${month}-${day}`;
        
        // Get time in 24-hour format
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        const timeStr = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        
        return { date: dateStr, time: timeStr };
    };

    const { date, time } = parseDateTime(value || "");

    const handleDateChange = (newDate: string) => {
        if (newDate && time) {
            const [hours, minutes] = time.split(":").map(Number);
            const dateObj = new Date(newDate);
            dateObj.setHours(hours, minutes, 0, 0);
            onChange?.(dateObj.toISOString());
        } else if (newDate) {
            const dateObj = new Date(newDate);
            dateObj.setHours(0, 0, 0, 0);
            onChange?.(dateObj.toISOString());
        }
    };

    const handleTimeChange = (newTime: string) => {
        if (date && newTime) {
            const [hours, minutes] = newTime.split(":").map(Number);
            const dateObj = new Date(date);
            dateObj.setHours(hours, minutes, 0, 0);
            onChange?.(dateObj.toISOString());
        }
    };

    return (
        <div className={`flex flex-col gap-2 ${className || ""}`}>
            <DatePickerMMDDYYYY
                value={date}
                onChange={handleDateChange}
                disabled={disabled}
            />
            <TimePicker12H
                value={time}
                onChange={handleTimeChange}
                disabled={disabled}
            />
        </div>
    );
}

